import { Box, Grid, Typography } from '@mui/material';
import parse from 'html-react-parser';
import React, { useContext, useEffect, useState } from 'react';

import TextFieldMemo from '../../../../../packages/common/shared-ui/src/components/TextFieldMemo/TextFieldMemo';
import { useTranslation } from '../../../../../packages/common/utils/getLocalString';
import { EditPageContext } from '../EditPageContext';

const UserPageMainInfo = ({ fields }) => {
  const [allFields, setAllFields] = useState([]);
  const getLocalString = useTranslation();
  const edit = useContext(EditPageContext);

  useEffect(() => {
    if (fields) {
      setAllFields(fields);
    }
  }, [fields]);

  return (
    <Grid container flexDirection={'column'}>
      {allFields &&
        allFields.length > 0 &&
        allFields.map(
          (control, index) =>
            control[0] !== 'redmineId' && (
              <Grid
                container
                key={index}
                sx={{
                  marginTop: index > 0 ? '4px' : 0,
                }}
              >
                <Grid
                  sx={{
                    width: '200px',
                  }}
                >
                  <Typography
                    variant='h4'
                    sx={{
                      color: '#41424E',
                      fontWeight: 700,
                    }}
                  >
                    {`${control.fieldName}:`}
                  </Typography>
                </Grid>
                <Box
                  component={'span'}
                  sx={{
                    color: '#212346',
                    wordBreak: 'break-word',
                  }}
                >
                  {control.fieldDefinition.fieldFormat === 'bool'
                    ? control.valueName === true
                      ? getLocalString('labels', 'yes')
                      : getLocalString('labels', 'no')
                    : control.valueName}
                </Box>
                {/*<TextFieldMemo disabled={!edit} value={control.valueName} label={control.fieldName} />*/}
              </Grid>
            ),
        )}
    </Grid>
  );
};

export default UserPageMainInfo;
